module.exports = __webpack_public_path__ + "static/media/Icon_awesome-exclamation-triangle.29199763.svg";